/**
 * @generated SignedSource<<b513451a6e678ba25e1a533963c437c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SaveAsTemplate_note$data = {
  readonly id: string;
  readonly rawDraftJson: any;
  readonly schemaVersion: number;
  readonly stream: {
    readonly id: string;
  };
  readonly title: string;
  readonly " $fragmentType": "SaveAsTemplate_note";
};
export type SaveAsTemplate_note$key = {
  readonly " $data"?: SaveAsTemplate_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveAsTemplate_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SaveAsTemplate_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawDraftJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schemaVersion",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "dfed3cd308acc92ceee6f8018413a06d";

export default node;
